const REQUIRED_COVERAGE_TYPE_LABELS = {
  'AUTO-LIABILITY': 'Auto Liability',
  'BIZ-INTERRUPT': 'Business Interruption',
  'BLDR-FLOOD': "Builder's Risk Flood",
  'BLDR-HAZARD': "Builder's Risk Hazard",
  'COMM-CONTENT': 'Commercial Contents',
  'COMM-LIABILITY': 'Commercial General Liability',
  'CONTRACTOR-LIABILITY': 'Contractor Liability',
  EARTHQUAKE: 'Earthquake',
  EQUIPMENT: 'Equipment Loan',
  'ERROR-OMIT': 'Errors & Omissions',
  FIRE: 'Fire',
  FLOOD: 'Flood',
  HAZARD: 'Hazard',
  HUR: 'Hurricane',
  'LENDER-AUTO-DAMAGE': 'Lender Coverage Auto Physical Damage',
  LIFE: 'Life',
  'LOSS-RENT': 'Loss of Rents',
  'PHYS-DAMAGE': 'Physical Damage',
  'POLLUTION-LIABILITY': 'Pollution Liability',
  'PROF-LIABILITY': 'Professional Liability',
  'REO-LIABILITY': 'Real Estate Owned',
  SINKHOLE: 'Sinkhole',
  WIND: 'Windstorm and Hail',
  'WORKER-COMP': "Workers' Compensation",
}

export const getRequiredCoverageTypeLabel = coverageType => {
  const key = String(coverageType ?? '').trim()

  return REQUIRED_COVERAGE_TYPE_LABELS[key] ?? coverageType
}
